import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { methodGetShelfBooks } from "../../../../../../api/apibook/api";
import { Book, BookKind, BookLimit, BookTemplate } from "../../../../../../model/book/Book";
import { useAppDispatch } from "../../../../../../store/hooks";
import { selectLogin } from "../../../../../../store/user/selector";
import { BookGrids } from "../../../../component/BookGrids";

export function SimulateList() {
    const dispatch = useAppDispatch();
    const login = useSelector(selectLogin);

    const updateBookShelf = useCallback(() => {
        methodGetShelfBooks(dispatch, {
            kind: BookKind.Simulate,
            noLogin: !login,
        }).then((rsp) => {
            setBookStore({ books: rsp.books, isBackend: true });
        });
    }, [dispatch, login]);

    const [bookStore, setBookStore] = useState({
        books: [] as Book[],
        isBackend: false,
    });

    useEffect(() => {
        if (bookStore.isBackend) {
            return;
        }
        updateBookShelf();
    }, [bookStore.isBackend, dispatch, updateBookShelf]);

    const placeHolderBooks = Array(1).fill({
        ...new Book(),
        title: "模考",
        sub_title: "点击创建新的模考",
        limit: BookLimit.Free,
        template: {
            ...new BookTemplate(),
            kind: BookKind.Simulate,
        },
    } as Book) as Book[];

    const displays = placeHolderBooks.concat(bookStore.books.filter((b) => !b.template.hide));
    return (
        <>
            <BookGrids books={displays} isSimulate={true} />
        </>
    );
}
